import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateCrmProject } from ".";
import { queryKeys } from "../../../../../lib/useQuery/queryKeys";

export function useUpdateCrmProject() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationKey: queryKeys.crm_project._def,
    mutationFn: updateCrmProject,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.crm_project._def,
        exact: false
      });
    },
  })
}
